

































import { Component, Vue } from 'vue-property-decorator';
import Button from '@/components/legacy/Button.vue';
import { ReviewsService } from '@/services/reviews.service';

@Component({
  components: {
    Button,
  },
})
export default class FeedbackPositiveView extends Vue {
  private get title(): string {
    return this.$store.getters['positiveReviewTitle'];
  }

  private get description(): string {
    return this.$store.getters['positiveReviewDescription'];
  }

  private goToGoogleMaps() {
    const id = this.$store.state['reviewId'];
    ReviewsService.setGoogleMapsClicked(id);
    const writeReviewUrl = this.$store.state['writeReviewUrl'];
    window.location.href = writeReviewUrl;
  }
}
